import styled from 'styled-components';
import {
  color,
  fontSize,
  fontWeight,
  radius,
  screen,
  spacing
} from '../../../../theme';
import { StyledBadges } from './CategoryBadge.styled';

export const StyledCard = styled.a`
  display: flex;
  flex-direction: row;
  align-items: stretch;
  text-decoration: none;
  border-radius: ${radius('lg')};
  background-color: ${color('white')};
  color: ${color('emerald_750')};
  transition: 0.3s ease;
  gap: ${spacing('lg')};

  &:hover {
    color: ${color('emerald_750')};
  }

  @media (max-width: ${screen('md')}) {
    flex-direction: column;
    align-items: center;
    text-align: center;
  }
`;

export const StyledThumb = styled.div`
  flex: 1 1 50%;
  position: relative;
  aspect-ratio: 4 / 3;
  overflow: hidden;
  border-radius: ${radius('md')};
  display: flex;
  align-items: center;
  justify-content: center;

  img {
    width: 100%;
    height: 100%;
    object-fit: cover;

    mask-image: url('/images/blog/irregular-box-white.svg');
    mask-size: 100% 100%;
    mask-repeat: no-repeat;
    mask-position: center;

    -webkit-mask-image: url('/images/blog/irregular-box-white.svg');
    -webkit-mask-size: 100% 100%;
    -webkit-mask-repeat: no-repeat;
    -webkit-mask-position: center;
  }

  @media (max-width: ${screen('sm')}) {
    width: 100%;
    flex: unset;
    aspect-ratio: auto;
    border-radius: ${radius('md')};
  }
`;

export const StyledEmptyThumb = styled.div`
  width: 100%;
  height: 100%;
  background-image: linear-gradient(
    47deg,
    ${color('purple_700')},
    ${color('mint_900')} 70%
  );
  display: flex;
  align-items: center;
  justify-content: center;

  img {
    height: auto;
    max-height: 60%;
  }
`;

export const StyledContent = styled.div`
  flex: 1 1 50%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  gap: ${spacing('xs')};
  text-align: left;

  @media (max-width: ${screen('sm')}) {
    width: 100%;
    flex: unset;
    align-items: center;
    text-align: center;
  }
`;

export const StyledDate = styled.p`
  display: inline-flex;
  align-items: end;
  gap: ${spacing('xs')};

  font-size: ${fontSize('sm')};
  line-height: 1;
  color: ${color('emerald_750')};
  margin: 0 0 ${spacing('xs')} 0;

  @media (max-width: ${screen('sm')}) {
    text-align: center;
  }
`;

export const StyledTitle = styled.h2`
  font-size: ${fontSize('lg')};
  font-weight: ${fontWeight('bold')};
  margin: 0;
  color: ${color('mint_800')};
`;

export const StyledExcerpt = styled.div`
  p:first-child {
    margin-top: 0;
  }

  p:last-child {
    margin-bottom: 0;
  }
`;

export const StyledTagsFix = styled(StyledBadges)`
  && {
    justify-content: flex-start;
  }
`;
